import { render, staticRenderFns } from "./NoCookiePage.vue?vue&type=template&id=f489a23c&scoped=true"
import script from "./NoCookiePage.vue?vue&type=script&lang=ts"
export * from "./NoCookiePage.vue?vue&type=script&lang=ts"
import style0 from "./NoCookiePage.vue?vue&type=style&index=0&id=f489a23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489a23c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/base/Icon/Icon.vue').default,CmStage: require('/app/components/modules/CmStage/CmStage.vue').default,RichText: require('/app/components/base/RichText/RichText.vue').default})
